import styled, { css } from "styled-components";

import { Divider as DefaultDivider } from "@material-ui/core";

import Loader from "components/Layout/Loader";

import { COLORS } from "constants/colorScheme";

interface IImageContainer {
  image: string;
  isDragging?: boolean;
  withIconControls?: boolean;
}

export const BackButtonWrapper = styled.div`
  display: flex;
  margin-left: 26px;
`;

export const DayContainer = styled.div`
  display: flex;
  flex-direction: column;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Divider = styled(DefaultDivider)`
  && {
    margin: 16px 0;
  }
`;

export const Images = styled.div`
  display: inline-flex;

  padding: 10px;

  border-radius: 8px;

  ${({ isDraggingOver }: { isDraggingOver?: boolean }) =>
    isDraggingOver &&
    css`
      background-color: ${COLORS.CYAN_LIGHT};
    `}
`;

export const IconControlsContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  display: none;

  transform: translate(-50%, -50%);

  z-index: 1;
`;

export const ScrollContainer = styled.div`
  margin: -10px;

  overflow-x: auto;
`;

export const ImageContainer = styled.div<IImageContainer>`
  display: flex;
  flex: 0 0 120px;

  position: relative;

  width: 120px;
  height: 120px;

  background-image: url(${({ image }) => image});
  background-size: cover;

  border-radius: 8px;

  ${({ isDragging }) =>
    isDragging &&
    css`
      border: 2px solid ${COLORS.CYAN};
      background-color: #fff;
    `};

  ${({ withIconControls }) =>
    withIconControls &&
    css`
      &:hover {
        ${IconControlsContainer} {
          display: flex;
          flex-direction: row;
        }

        &:after {
          content: "";

          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;

          border-radius: 8px;

          background-color: rgba(255, 255, 255, 0.7);
        }
      }
    `}

  &:not(:last-child) {
    margin-right: 24px;
  }
`;

export const OverflowLoader = styled(Loader)`
  position: absolute;
  z-index: 10;

  background-color: ${COLORS.WHITE_40};
`;

export const Wrapper = styled.div``;
